import { HFItem, StaffItem } from "./components";
import { DoctorItem } from "./components/doctorItem";
import { PatientItem } from "./components/patientItem";
import { PatternItem } from "./components/patternItem";
import { TerminologyItem } from "./components/terminologyItem";
import type { IAllInfiniteConfig, IInfiniteConfig } from "./config";
import { infiniteQueryHooksMap } from "./config";

import { VisitHistories } from "@api/infiniteDropdowns/mapperConfig/components/visitHistories";
import { ITerminologiesKindEnum } from "@/interfaces";

export const hf: IInfiniteConfig<"hf"> = {
  useHook: infiniteQueryHooksMap.hf,
  mapper(value) {
    return value.list.map((item) => ({
      key: item.id,
      value: item.name,
      ...item,
    }));
  },
  itemNode(value) {
    return <HFItem {...value} />;
  },
};

export const doctor: IInfiniteConfig<"doctor"> = {
  useHook: infiniteQueryHooksMap.doctor,
  mapper(value) {
    return value.list.map((item) => ({
      key: item.id,
      value: `${item.first_name} ${item.last_name}`,
      ...item,
    }));
  },
  itemNode(value) {
    return <DoctorItem {...value} />;
  },
};

export const assignableDoctorsToStaff: IInfiniteConfig<"assignableDoctorsToStaff"> =
  {
    useHook: infiniteQueryHooksMap.assignableDoctorsToStaff,
    mapper(value) {
      return value.list.map((item) => ({
        key: item.id,
        value: `${item.first_name} ${item.last_name}`,
        ...item,
      }));
    },
    hookOptions: (variables) => ({
      enabled: !!variables.staffId,
    }),
    itemNode(value) {
      return <DoctorItem {...value} />;
    },
  };

export const assignableDoctorsToMsp: IInfiniteConfig<"assignableDoctorsToMsp"> =
  {
    useHook: infiniteQueryHooksMap.assignableDoctorsToMsp,
    mapper(value) {
      return value.list.map((item) => ({
        key: item.id,
        value: `${item.first_name} ${item.last_name}`,
        ...item,
      }));
    },
    hookOptions: (variables) => ({
      enabled: !!variables.mspId,
    }),
    itemNode(value) {
      return <DoctorItem {...value} />;
    },
  };

export const staff: IInfiniteConfig<"staff"> = {
  useHook: infiniteQueryHooksMap.staff,
  mapper(value) {
    return value.list.map((item) => ({
      key: item.id,
      value: `${item.first_name} ${item.last_name}`,
      ...item,
    }));
  },
  itemNode(value) {
    return <StaffItem {...value} />;
  },
};

export const patterns: IInfiniteConfig<"patterns"> = {
  useHook: infiniteQueryHooksMap.patterns,
  mapper(value) {
    return value.list.map((item) => ({
      key: item.id,
      value: item.name,
      ...item,
    }));
  },
  itemNode(value) {
    return <PatternItem {...value} />;
  },
};

export const suggestedPatterns: IInfiniteConfig<"suggestedPatterns"> = {
  useHook: infiniteQueryHooksMap.suggestedPatterns,
  mapper(value) {
    return value.list.map((item) => ({
      key: item.id,
      value: item.name,
      ...item,
    }));
  },
  itemNode(value) {
    return <PatternItem {...value} />;
  },
};

export const terminologies: IInfiniteConfig<"terminologies"> = {
  useHook: infiniteQueryHooksMap.terminologies,
  mapper(value) {
    return value.list.map((item) => ({
      key: item.code,
      // value: item.value,
      ...item,
    }));
  },
  itemNode(value) {
    return <TerminologyItem {...value} />;
  },
};

export const diseases: IInfiniteConfig<"diseases"> = {
  useHook: infiniteQueryHooksMap.diseases,
  mapper(value) {
    return value.list.map((item) => ({
      key: item.code,
      ...item,
    }));
  },
  itemNode(value) {
    return (
      <TerminologyItem
        {...value}
        type={{ key: ITerminologiesKindEnum.DoctorService, value: "" }}
        description={""}
      />
    );
  },
};

export const visitHistories: IInfiniteConfig<"visitHistories"> = {
  useHook: infiniteQueryHooksMap.visitHistories,
  mapper(value) {
    return value.list.map((item) => ({
      ...item,
    }));
  },
  itemNode(value) {
    return <VisitHistories {...value} />;
  },
};

export const patient: IInfiniteConfig<"patient"> = {
  useHook: infiniteQueryHooksMap.patient,
  mapper(value) {
    return value.list.map((item) => ({
      key: item.id,
      value: `${item.first_name} ${item.last_name}`,
      ...item,
    }));
  },
  itemNode(value) {
    return <PatientItem {...value} />;
  },
};

export const mspName: IInfiniteConfig<"mspName"> = {
  useHook: infiniteQueryHooksMap.mspName,
  mapper(value) {
    return value.list.map((item) => ({
      ...item,
    }));
  },
};

export const allInfiniteConfig: IAllInfiniteConfig = {
  hf,
  assignableDoctorsToStaff,
  doctor,
  staff,
  patterns,
  patient,
  suggestedPatterns,
  terminologies,
  visitHistories,
  diseases,
  mspName,
  assignableDoctorsToMsp,
};
